import { render } from "./RemembrView.vue?vue&type=template&id=d25d05f4&scoped=true"
import script from "./RemembrView.vue?vue&type=script&lang=js"
export * from "./RemembrView.vue?vue&type=script&lang=js"

import "./RemembrView.vue?vue&type=style&index=0&id=d25d05f4&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25d05f4"]])

export default __exports__